var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('date-pick',{attrs:{"displayFormat":'DD-MM-YYYY'},model:{value:(_vm.dob),callback:function ($$v) {_vm.dob=$$v},expression:"dob"}})}
var staticRenderFns = []

export { render, staticRenderFns }